import React, { useEffect } from "react";

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <h1 className="mb-4 text-center">Privacy Policy</h1>

          <p><strong>Privacy Policy for Sri Raghavendra Decors & Events</strong></p>
          <p>Effective Date: April 18, 2026</p>
          <p>Website: sriraghavendradecorators.com</p>

          <p>
            Sri Raghavendra Decors & Events (“Company,” “we,” “our,” or “us”)
            values your privacy. This Privacy Policy explains how we collect,
            use, store, and protect your information when you visit our website
            or contact us for our services. This policy is designed for an event
            management and wedding decoration business in India.
          </p>

          <h3 className="mt-4">1. Information We Collect</h3>

          <p>We may collect the following information when you interact with us:</p>

          <h5 className="mt-3">Personal Information</h5>
          <ul>
            <li>Full Name</li>
            <li>Phone Number</li>
            <li>Email Address</li>
            <li>Event Location</li>
            <li>Event Date</li>
            <li>Service Requirements</li>
            <li>Messages or Enquiries you submit</li>
          </ul>

          <h5 className="mt-3">Automatically Collected Information</h5>
          <ul>
            <li>IP Address</li>
            <li>Browser Type</li>
            <li>Device Information</li>
            <li>Website Usage Data</li>
            <li>Cookies and Tracking Data</li>
          </ul>

          <h3 className="mt-4">2. How We Collect Information</h3>

          <p>We collect information through:</p>

          <ul>
            <li>Contact Forms on the website</li>
            <li>WhatsApp or Phone Calls</li>
            <li>Email Communication</li>
            <li>Cookies</li>
            <li>Analytics Tools</li>
            <li>Advertising Platforms such as Google Ads and Meta Ads</li>
          </ul>

          <h3 className="mt-4">3. How We Use Your Information</h3>

          <p>We use your information to:</p>

          <ul>
            <li>Respond to enquiries</li>
            <li>Provide quotations</li>
            <li>Confirm bookings</li>
            <li>Deliver decoration and event services</li>
            <li>Improve our website and customer experience</li>
            <li>Send updates or promotional offers</li>
            <li>Run advertising campaigns</li>
            <li>Maintain business records</li>
          </ul>

          <h3 className="mt-4">4. Sharing of Information</h3>

          <p>We do not sell your personal information.</p>

          <p>We may share information only with:</p>

          <ul>
            <li>Trusted team members or staff</li>
            <li>Payment providers (if used)</li>
            <li>Website hosting providers</li>
            <li>Marketing platforms</li>
            <li>Legal authorities when required by law</li>
          </ul>

          <h3 className="mt-4">5. Cookies Policy</h3>

          <p>
            Our website may use cookies to improve your browsing experience,
            analyze traffic, and personalize ads. You can disable cookies in
            your browser settings.
          </p>

          <h3 className="mt-4">6. Data Security</h3>

          <p>
            We take reasonable security measures to protect your personal
            information from unauthorized access, misuse, or disclosure.
            However, no online platform can guarantee 100% security.
          </p>

          <h3 className="mt-4">7. Your Rights</h3>

          <p>You may request to:</p>

          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate information</li>
            <li>Delete your information</li>
            <li>Withdraw marketing consent</li>
          </ul>

          <p>To make a request, contact us using the details below.</p>

          <h3 className="mt-4">8. Third-Party Links</h3>

          <p>
            Our website may contain links to third-party websites such as social
            media platforms. We are not responsible for their privacy practices.
          </p>

          <h3 className="mt-4">9. Children's Privacy</h3>

          <p>
            Our services are not intended for children under 13 years of age.
            We do not knowingly collect data from children.
          </p>

          <h3 className="mt-4">10. Changes to This Policy</h3>

          <p>
            We may update this Privacy Policy from time to time. Changes will
            be posted on this page with the revised effective date.
          </p>

          <h3 className="mt-4">11. Contact Us</h3>

          <p>Sri Raghavendra Decors & Events</p>
          <p>Coimbatore, Tamil Nadu, India</p>
          <p>📞 +91 98940 90587</p>
          <p>🌐 Visit Website</p>

          <p>
            If you have any questions regarding this Privacy Policy, please
            contact us.
          </p>

          <h2 className="mt-5 mb-4 text-center">Privacy Policy</h2>

          <p><strong>Sri Raghavendra Decors & Events</strong></p>
          <p>Website: https://sriraghavendradecorators.com/</p>
          <p>Effective Date: April 18, 2026</p>
          <p>Last Updated: April 18, 2026</p>

          <p>
            Sri Raghavendra Decors & Events (“we,” “our,” “us”) respects your
            privacy and is committed to protecting your personal information.
            This Privacy Policy explains how we collect, use, disclose, store,
            and safeguard your information when you visit our website, contact
            us, request services, or interact with our business online or
            offline.
          </p>

          <p>
            By using our website or sharing your information with us, you agree
            to the practices described in this Privacy Policy.
          </p>

          <h3 className="mt-4">1. About Us</h3>

          <p>
            Sri Raghavendra Decors & Events is an event management and
            decoration company based in Coimbatore, Tamil Nadu, India, serving
            clients across India for weddings, receptions, corporate events,
            religious functions, birthday parties, baby showers, exhibitions,
            and other special occasions.
          </p>

          <p>Contact Details:</p>
          <p>📞 +91 98940 90587 / +91 95971 90587</p>
          <p>🌐 https://sriraghavendradecorators.com/</p>

          <h3 className="mt-4">2. Information We Collect</h3>

          <p>
            We may collect personal and non-personal information depending on
            how you interact with us.
          </p>

          <h5 className="mt-3">2.1 Personal Information</h5>
          <ul>
            <li>Full name</li>
            <li>Mobile number</li>
            <li>Email address</li>
            <li>City / State / Country</li>
            <li>Event venue details</li>
            <li>Event date and time</li>
            <li>Type of event</li>
            <li>Decoration preferences</li>
            <li>Budget details (if shared)</li>
            <li>Communication history</li>
            <li>Any documents, images, or references shared by you</li>
          </ul>

          <h5 className="mt-3">2.2 Automatically Collected Information</h5>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device type</li>
            <li>Operating system</li>
            <li>Pages visited</li>
            <li>Time spent on pages</li>
            <li>Referring website</li>
            <li>Click behavior</li>
            <li>Approximate location data</li>
            <li>Cookies and similar technologies</li>
          </ul>

          <h5 className="mt-3">2.3 Social Media Information</h5>
          <p>
            If you contact us through platforms like Instagram, Facebook,
            WhatsApp, YouTube, or other social media channels, we may receive
            the information you share through those platforms.
          </p>

          <h3 className="mt-4">3. How We Collect Information</h3>

          <p>We may collect information through:</p>

          <ul>
            <li>Website contact forms</li>
            <li>Enquiry forms</li>
            <li>Call requests</li>
            <li>Phone calls</li>
            <li>WhatsApp chats</li>
            <li>Emails</li>
            <li>Social media messages</li>
            <li>Online advertisements</li>
            <li>Booking discussions</li>
            <li>In-person meetings</li>
            <li>Event consultations</li>
            <li>Cookies and analytics tools</li>
          </ul>

          <h3 className="mt-4">4. Purpose of Collecting Information</h3>

          <p>
            We use your information for legitimate business purposes,
            including:
          </p>

          <h5 className="mt-3">Service Purposes</h5>
          <ul>
            <li>Responding to enquiries</li>
            <li>Understanding your event requirements</li>
            <li>Providing quotations</li>
            <li>Confirming bookings</li>
            <li>Planning and executing events</li>
            <li>Customer support before, during, and after events</li>
          </ul>

          <h5 className="mt-3">Business Operations</h5>
          <ul>
            <li>Internal record keeping</li>
            <li>Managing customer relationships</li>
            <li>Improving our services</li>
            <li>Staff coordination</li>
            <li>Vendor coordination</li>
          </ul>

          <h5 className="mt-3">Marketing Purposes</h5>
          <ul>
            <li>Sending offers or updates</li>
            <li>Showcasing services</li>
            <li>Running ad campaigns</li>
            <li>Retargeting website visitors</li>
            <li>Measuring ad performance</li>
          </ul>

          <h5 className="mt-3">Legal & Security Purposes</h5>
          <ul>
            <li>Preventing fraud</li>
            <li>Resolving disputes</li>
            <li>Enforcing agreements</li>
            <li>Complying with applicable laws</li>
          </ul>

          <h3 className="mt-4">5. Legal Basis for Processing Information</h3>

          <ul>
            <li>Your consent</li>
            <li>Performance of a contract</li>
            <li>Legitimate business interests</li>
            <li>Compliance with legal obligations</li>
          </ul>

          <h3 className="mt-4">6. Cookies and Tracking Technologies</h3>

          <p>
            Our website may use cookies, pixels, tags, and similar technologies
            to improve user experience and analyze website traffic.
          </p>

          <ul>
            <li>Essential cookies</li>
            <li>Performance cookies</li>
            <li>Analytics cookies</li>
            <li>Advertising cookies</li>
            <li>Remarketing pixels</li>
          </ul>

          <p>
            You may disable cookies through your browser settings. However,
            some website features may not function properly.
          </p>

          <h3 className="mt-4">7. Third-Party Services We May Use</h3>

          <ul>
            <li>Google Ads</li>
            <li>Meta Ads (Facebook / Instagram)</li>
            <li>Google Analytics</li>
            <li>Website hosting providers</li>
            <li>Domain providers</li>
            <li>CRM tools</li>
            <li>Communication platforms</li>
            <li>Payment providers (if applicable)</li>
          </ul>

          <p>
            These third parties may process data according to their own privacy
            policies.
          </p>

          <h3 className="mt-4">8. Sharing of Information</h3>

          <p>We do not sell, rent, or trade your personal information.</p>

          <ul>
            <li>Internal staff members</li>
            <li>Event coordinators</li>
            <li>Trusted vendors</li>
            <li>Website service providers</li>
            <li>Advertising partners</li>
            <li>Payment processors</li>
            <li>Legal or regulatory authorities</li>
            <li>Professional advisors</li>
          </ul>

          <p>All sharing is limited to what is reasonably necessary.</p>

          <h3 className="mt-4">9. Data Retention</h3>

          <ul>
            <li>Service fulfilment</li>
            <li>Customer support</li>
            <li>Legal compliance</li>
            <li>Accounting records</li>
            <li>Business operations</li>
            <li>Marketing records (until opt-out)</li>
          </ul>

          <p>
            When no longer required, data may be securely deleted or anonymized.
          </p>

          <h3 className="mt-4">10. Data Security</h3>

          <ul>
            <li>Unauthorized access</li>
            <li>Loss</li>
            <li>Misuse</li>
            <li>Alteration</li>
            <li>Disclosure</li>
            <li>Destruction</li>
          </ul>

          <p>
            However, no method of transmission over the internet or electronic
            storage is completely secure.
          </p>

          <h3 className="mt-4">11. Your Rights and Choices</h3>

          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion</li>
            <li>Withdraw consent</li>
            <li>Object to certain processing</li>
            <li>Restrict processing</li>
            <li>Request data portability</li>
            <li>Opt out of marketing communications</li>
          </ul>

          <p>
            To exercise any of these rights, contact us using the details below.
          </p>

          <h3 className="mt-4">12. Marketing Communications</h3>

          <ul>
            <li>Your enquiry</li>
            <li>Quotations</li>
            <li>Booking updates</li>
            <li>Offers</li>
            <li>Promotions</li>
            <li>New services</li>
          </ul>

          <p>
            You may opt out of promotional communications at any time by
            informing us.
          </p>

          <h3 className="mt-4">13. Third-Party Links</h3>

          <p>
            Our website or social media pages may contain links to external
            websites. We are not responsible for the privacy practices,
            content, or policies of third-party websites.
          </p>

          <p>Please review their policies separately.</p>

          <h3 className="mt-4">14. Children’s Privacy</h3>

          <p>
            Our services are generally intended for adults planning events. We
            do not knowingly collect personal information from children without
            parental consent.
          </p>

          <p>
            If you believe a child has provided information to us, please
            contact us for removal.
          </p>

          <h3 className="mt-4">15. International Users</h3>

          <p>
            If you access our website from outside India, your information may
            be processed and stored in India or other countries where our
            service providers operate.
          </p>

          <p>
            By using our services, you consent to such transfer where permitted
            by law.
          </p>

          <h3 className="mt-4">16. Changes to This Privacy Policy</h3>

          <ul>
            <li>Legal changes</li>
            <li>Technology updates</li>
            <li>Service changes</li>
            <li>Business practices</li>
          </ul>

          <p>
            Updated versions will be posted on this page with the revised
            effective date.
          </p>

          <h3 className="mt-4">17. Contact Us</h3>

          <p>
            If you have questions, requests, or concerns regarding this Privacy
            Policy, please contact:
          </p>

          <p>Sri Raghavendra Decors & Events</p>
          <p>Coimbatore, Tamil Nadu, India</p>
          <p>📞 +91 98940 90587 / +91 95971 90587</p>
          <p>🌐 https://sriraghavendradecorators.com/</p>

          <h3 className="mt-4">18. Consent</h3>

          <p>
            By using our website, submitting your details, or contacting us,
            you consent to the collection and use of information as described
            in this Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;